module.exports = ".form-group{margin-bottom:15px}input{width:100%;padding:10px;font-size:14px;border:1px solid #ccc;border-radius:4px}\n"